var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-checkbox',{model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }